import { Component } from '@angular/core';
import { DialogBaseComponent, DialogParams } from './dialog-base.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DomainService } from './domain.service';

export interface OneFieldDialogParams extends DialogParams {
  title: string;
  fieldName: string;
  fieldValue?: any;
  buttons?: string[];
  fieldType?: 'integer' | 'float' | 'string';
}

export interface OneFieldResult {
  value: any;
  button: string;
  index: number;
}

@Component({
    templateUrl: './one-field-dialog.component.html',
    standalone: false
})
export class OneFieldDialogComponent extends DialogBaseComponent<OneFieldDialogParams> {
  title: string;
  fieldName: string;
  fieldValue: any;
  fieldType: 'integer' | 'float' | 'string';
  buttons: string[];

  constructor(public config: DynamicDialogConfig<OneFieldDialogParams>, public dialogRef: DynamicDialogRef,
    public domainService: DomainService
  ) {
    super(config, dialogRef, domainService);
    Object.assign(this.config, {
      width: '600px',
      height: '400px'
    });    
    this.prepare();
  }

  async prepare() {
    this.config.header = this.params.title;
    this.fieldName = this.params.fieldName;
    this.fieldValue = this.params.fieldValue;
    this.buttons = this.params.buttons ?? ['Ok', 'Cancel'];
    this.fieldType = this.params.fieldType ?? 'string';
    this.isPageReady = true;
  }

  async select(index: number) {
    let value = null; 
    if (index == 0 ) {
      value = await this.validateValue();
      if (value == null) return;
    } 
      
    const result = {
      value: value,
      button: this.buttons[index],
      index: index
    } as OneFieldResult;
    
    this.dialogRef.close(result);
  }

  async validateValue() {
    if (this.fieldType === 'string') {
      return this.fieldValue && this.fieldValue.trim();
    } 
    let value;
    if (this.fieldType == 'integer') {
      value = Number.parseInt(this.fieldValue);
    } else if (this.fieldType == 'float') {
      value = Number.parseFloat(this.fieldValue);
    }
    if (Number.isNaN(value)) {
      await this.dialogService.showOkMessage('Not a ' + this.fieldType, `${this.fieldName} must be a ${this.fieldType}`);
      return null;
    }
    return value;
  }
}
